import { mapActions, mapGetters } from 'vuex';
import { Utils } from '../assets/resources/js/utils.js';

const utils = new Utils();

export default {
  data() {
    return {
      utils
    };
  },
  computed: {
    ...mapGetters({
      searchFilter: 'template/getSearchFilter'
    })
  },
  methods: {
    ...mapActions({
      setSearchFilter: 'template/setSearchFilter'
    })
  }
};
